import jjv from 'jjv'
import moment from 'moment'
import cache from '../core/cache'
import {phoneFormat} from '../core/phonez'

export const WEEK_DAYS = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY']
export const FOR_WHATS = ['RequestForQuotation', 'Urgency']
export const FOR_WHOS =  ['Individuals', 'Professionals']
export const PERIOD_TYPES = ['DateTimePeriod', 'WeekDaysPeriod', 'SpecificDaysPeriod']
export const TIME_SLOT_TYPES = ['AllDayLong', 'HourPeriods']
export const CHARGE_TYPES = ['FixChargeValue', 'ChargePercentage']

export class InterventionPeriod {
}

InterventionPeriod.isExpired = function(interventionPeriod) {
    const now = new Date()

    function lastDayReducer(result, day) {
        const dayz = moment(day).toDate()
        if (!result || dayz > result) {
            result = dayz
        }
        return result
    }

    if (interventionPeriod.period.days) {
        const lastDay = interventionPeriod.period.days.reduce(lastDayReducer, null)
        if (lastDay < now) return true
    }

    if (interventionPeriod.period.endDate) {
        const endDate = moment(interventionPeriod.period.endDate).toDate()
        if (endDate < now) return true
    }

    return false
}

export function createValidator() {
    const validator = jjv()

    validator.addFormat('phone', phoneFormat)
    return validator
}

export function resolveActivities(ref, activities) {
    ref = ref || []

    return activities.map((activity) => {
        return ref.find((a) => a.uid == activity.activityUid)
    }).filter((a) => a)
}

export class ProviderCriteria {
}

ProviderCriteria.schema = {
    type: 'object',
    properties: {
        fullText: {type: 'string'},
        activityUid: {type: 'array'},
        filtered: {type: 'boolean'}
    }
}

export class ProviderCoverageCriteria {
}

ProviderCoverageCriteria.schema = {
    type: 'object',
    properties: {
        zipCodes: {type: ['string', 'null']},
        department: {type: 'object'},
        city: {type: 'object'},
        activityUids: {type: 'array'}
    },
    required: ['activityUids']
}

export class ContactCriteria {
}

ContactCriteria.schema = {
    type: 'object',
    properties: {
        fullText: {type: 'string'}
    }
}

export class Filter {
}

Filter.schema = {
    type: 'object',
    properties: {
        from: {type: 'date'},
        to: {type: 'date'}
    }
}

export class ReferenceProviderCompanyCmd {
}

ReferenceProviderCompanyCmd.schema = {
    type: 'object',
    properties: {
        label: {type: 'string'},
        siretNumber: {
            type: 'string',
            pattern: '^[a-zA-Z0-9]{14}$'
        }
    },
    required: ['label', 'siretNumber']
}

export class AddProviderContactCmd {
}

AddProviderContactCmd.schemaCache = cache()

AddProviderContactCmd.schema = {
    type: 'object',
    properties: {
        namez: {
            oneOf: [{
                type: 'object',
                properties: {
                    firstName: {type: 'string'},
                    lastName: {type: 'string'},
                    gender: {type: ['string', 'null']},
                    nameType: {
                        type: 'string',
                        enum: ['CivilName']
                    }
                },
                required: ['firstName', 'lastName', 'nameType']
            }, {
                type: 'object',
                properties: {
                    value: {type: 'string'},
                    nameType: {
                        type: 'string',
                        enum: ['PoorName']
                    }
                },
                required: ['value', 'nameType']
            }]
        },
        emails: {
            type: ['array', 'null'],
            items: {
                type: 'string',
                format: 'email'
            }
        },
        phones: {
            type: ['array', 'null'],
            items: {
                type: 'string',
                format: 'phone'
            }
        },
        fax: {
            type: ['array', 'null'],
            items: {
                type: 'string',
                format: 'phone'
            }
        },
        companyUid: {type: 'object'},
        providerCompanyUid: {type: 'object'}
    },
    required: ['namez', 'companyUid', 'providerCompanyUid']
}

AddProviderContactCmd.selectSchema = (cmd) => {
    const nameType = cmd && cmd.namez && cmd.namez.nameType || 'CivilName'

    return AddProviderContactCmd.schemaCache(nameType, () => {
        const namezSchema = AddProviderContactCmd.schema.properties.namez.oneOf.find((schema) => {
            return schema.properties.nameType.enum.indexOf(nameType) >= 0
        })

        return {
            ...AddProviderContactCmd.schema,
            properties: {
                ...AddProviderContactCmd.schema.properties,
                namez: namezSchema
            }
        }
    })
}

export class UpdateProviderContactCmd {
}

UpdateProviderContactCmd.schemaCache = cache()

UpdateProviderContactCmd.schema = {
    type: 'object',
    properties: {
        namez: {
            oneOf: [{
                type: 'object',
                properties: {
                    firstName: {type: 'string'},
                    lastName: {type: 'string'},
                    gender: {type: ['string', 'null']},
                    nameType: {
                        type: 'string',
                        enum: ['CivilName']
                    }
                },
                required: ['firstName', 'lastName', 'nameType']
            }, {
                type: 'object',
                properties: {
                    value: {type: 'string'},
                    nameType: {
                        type: 'string',
                        enum: ['PoorName']
                    }
                },
                required: ['value', 'nameType']
            }]
        },
        emails: {
            type: 'array',
            items: {
                type: 'string',
                format: 'email'
            }
        },
        phones: {
            type: 'array',
            items: {
                type: 'string',
                format: 'phone'
            }
        },
        fax: {
            type: 'array',
            items: {
                type: 'string',
                format: 'phone'
            }
        }
    },
    required: ['namez']
}

UpdateProviderContactCmd.selectSchema = (cmd) => {
    const nameType = cmd && cmd.namez && cmd.namez.nameType || 'CivilName'

    return UpdateProviderContactCmd.schemaCache(nameType, () => {
        const namezSchema = UpdateProviderContactCmd.schema.properties.namez.oneOf.find((schema) => {
            return schema.properties.nameType.enum.indexOf(nameType) >= 0
        })

        return {
            ...UpdateProviderContactCmd.schema,
            properties: {
                ...UpdateProviderContactCmd.schema.properties,
                namez: namezSchema
            }
        }
    })
}

export class AssociateProviderContactWithProviderCompanyCmd {
}

AssociateProviderContactWithProviderCompanyCmd.schema = {
    type: 'object',
    properties: {
        providerCompanyUid: {type: 'object'}
    },
    required: ['providerCompanyUid']
}

export class AssignActivityToProviderCompanyCmd {
}

AssignActivityToProviderCompanyCmd.schema = {
    type: 'object',
    properties: {
        activityUid: {type: 'object'}
    },
    required: ['activityUid']
}

export class DefineUpdateInterventionPeriodForActivityCmd {
}

DefineUpdateInterventionPeriodForActivityCmd.schemaCache = cache()
DefineUpdateInterventionPeriodForActivityCmd.alternateSchemaCache = cache()

DefineUpdateInterventionPeriodForActivityCmd.schema = {
    type: 'object',
    properties: {
        period: {
            oneOf: [{
                type: 'object',
                properties: {
                    label: {type: 'string'},
                    startDate: {type: 'date'},
                    endDate: {type: 'date'},
                    periodType: {
                        type: 'string',
                        enum: ['DateTimePeriod']
                    }
                },
                required: ['label', 'startDate', 'endDate', 'periodType']
            }, {
                type: 'object',
                properties: {
                    label: {type: 'string'},
                    periodRanges: {
                        type: 'array',
                        minItems: 1,
                        items: {
                            type: 'object',
                            properties: {
                                weekDays: {
                                    type: 'array',
                                    minItems: 1
                                },
                                timeSlot: {
                                    oneOf: [{
                                        type: 'object',
                                        properties: {
                                            timeSlotType: {
                                                type: 'string',
                                                enum: ['AllDayLong']
                                            }
                                        },
                                        required: ['timeSlotType']
                                    }, {
                                        type: 'object',
                                        properties: {
                                            periods: {
                                                type: 'array',
                                                minItems: 1,
                                                items: {
                                                    type: 'object',
                                                    properties: {
                                                        start: {type: 'date'},
                                                        end: {type: 'date'}
                                                    },
                                                    required: ['start', 'end']
                                                }
                                            },
                                            timeSlotType: {
                                                type: 'string',
                                                enum: ['HourPeriods']
                                            }
                                        },
                                        required: ['periods', 'timeSlotType']
                                    }]
                                }
                            },
                            required: ['weekDays', 'timeSlot']
                        }
                    },
                    exclusions: {
                        type: ['array', 'null'],
                        items: {
                            type: 'object',
                            properties: {
                                days: {
                                    type: 'array',
                                    minItems: 1,
                                    items: {type: 'date'}
                                },
                                timeSlot: {
                                    oneOf: [{
                                        type: 'object',
                                        properties: {
                                            timeSlotType: {
                                                type: 'string',
                                                enum: ['AllDayLong']
                                            }
                                        },
                                        required: ['timeSlotType']
                                    }, {
                                        type: 'object',
                                        properties: {
                                            periods: {
                                                type: 'array',
                                                minItems: 1,
                                                items: {
                                                    type: 'object',
                                                    properties: {
                                                        start: {type: 'date'},
                                                        end: {type: 'date'}
                                                    },
                                                    required: ['start', 'end']
                                                }
                                            },
                                            timeSlotType: {
                                                type: 'string',
                                                enum: ['HourPeriods']
                                            }
                                        },
                                        required: ['periods', 'timeSlotType']
                                    }]
                                }
                            },
                            required: ['days', 'timeSlot']
                        }
                    },
                    startDate: {type: ['date', 'null']},
                    endDate: {type: ['date', 'null']},
                    periodType: {
                        type: 'string',
                        enum: ['WeekDaysPeriod']
                    }
                },
                required: ['label', 'periodRanges', 'periodType']
            }, {
                type: 'object',
                properties: {
                    label: {type: 'string'},
                    days: {
                        type: 'array',
                        minItems: 1,
                        items: {type: 'date'}
                    },
                    timeSlot: {
                        oneOf: [{
                            type: 'object',
                            properties: {
                                timeSlotType: {
                                    type: 'string',
                                    enum: ['AllDayLong']
                                }
                            },
                            required: ['timeSlotType']
                        }, {
                            type: 'object',
                            properties: {
                                periods: {
                                    type: 'array',
                                    minItems: 1,
                                    items: {
                                        type: 'object',
                                        properties: {
                                            start: {type: 'date'},
                                            end: {type: 'date'}
                                        },
                                        required: ['start', 'end']
                                    }
                                },
                                timeSlotType: {
                                    type: 'string',
                                    enum: ['HourPeriods']
                                }
                            },
                            required: ['periods', 'timeSlotType']
                        }]
                    },
                    periodType: {
                        type: 'string',
                        enum: ['SpecificDaysPeriod']
                    }
                },
                required: ['label', 'days', 'periodType']
            }]
        }
    },
    required: ['period']
}

DefineUpdateInterventionPeriodForActivityCmd.selectSchema = (cmd) => {
    const periodType = cmd && cmd.period && cmd.period.periodType || PERIOD_TYPES[0]
    const periodTimeSlotType = cmd && cmd.period && cmd.period.timeSlot && cmd.period.timeSlot.timeSlotType || TIME_SLOT_TYPES[0]

    return DefineUpdateInterventionPeriodForActivityCmd.schemaCache([periodType, periodTimeSlotType], () => {
        const periodSchema = DefineUpdateInterventionPeriodForActivityCmd.schema.properties.period.oneOf.find((schema) => {
            return schema.properties.periodType.enum.indexOf(periodType) >= 0
        })

        const periodTimeSlotSchema = periodSchema.properties.timeSlot && periodSchema.properties.timeSlot.oneOf.find((schema) => {
            return schema.properties.timeSlotType.enum.indexOf(periodTimeSlotType) >= 0
        })

        if (periodTimeSlotSchema) {
            return {
                ...DefineUpdateInterventionPeriodForActivityCmd.schema,
                properties: {
                    ...DefineUpdateInterventionPeriodForActivityCmd.schema.properties,
                    period: {
                        ...periodSchema,
                        properties: {
                            ...periodSchema.properties,
                            timeSlot: periodTimeSlotSchema
                        }
                    }
                }
            }
        }

        return {
            ...DefineUpdateInterventionPeriodForActivityCmd.schema,
            properties: {
                ...DefineUpdateInterventionPeriodForActivityCmd.schema.properties,
                period: periodSchema
            }
        }        
    })
}

DefineUpdateInterventionPeriodForActivityCmd.selectAlternateSchema = (cmd) => {
    // resolve oneOf definitions which are nested in arrays.
    // this can't be done in selectSchema ; otherwise validation will fail
    const periodRangeTimeSlotType = cmd && cmd.period && cmd.period.periodRanges && cmd.period.periodRanges[0] && cmd.period.periodRanges[0].timeSlot && cmd.period.periodRanges[0].timeSlot.timeSlotType || TIME_SLOT_TYPES[0]
    const exclusionTimeSlotType = cmd && cmd.period && cmd.period.exclusions && cmd.period.exclusions[0] && cmd.period.exclusions[0].timeSlot && cmd.period.exclusions[0].timeSlot.timeSlotType || TIME_SLOT_TYPES[0]

    return DefineUpdateInterventionPeriodForActivityCmd.alternateSchemaCache([periodRangeTimeSlotType, exclusionTimeSlotType], () => {
        const periodSchema = DefineUpdateInterventionPeriodForActivityCmd.schema.properties.period.oneOf.find((schema) => {
            return schema.properties.periodType.enum.indexOf('WeekDaysPeriod') >= 0
        })

        const periodRangeTimeSlotSchema = periodSchema.properties.periodRanges.items.properties.timeSlot.oneOf.find((schema) => {
            return schema.properties.timeSlotType.enum.indexOf(periodRangeTimeSlotType) >= 0
        })

        const exclusionTimeSlotSchema = periodSchema.properties.exclusions.items.properties.timeSlot.oneOf.find((schema) => {
            return schema.properties.timeSlotType.enum.indexOf(exclusionTimeSlotType) >= 0
        })

        return {
            properties: {
                period: {
                    properties: {
                        periodRanges: {
                            items: {
                                properties: {
                                    timeSlot: periodRangeTimeSlotSchema
                                }
                            }
                        },
                        exclusions: {
                            items: {
                                properties: {
                                    timeSlot: exclusionTimeSlotSchema
                                }
                            }
                        }
                    }
                }
            }
        }
    })
}

export class DefineServiceChargeForInterventionPeriodCmd {
}

DefineServiceChargeForInterventionPeriodCmd.schema = {
    type: 'object',
    properties: {
        charge: {
            type: 'object',
            properties: {
                value: {type: 'number'},
                chargeType: {type: 'string'}
            },
            required: ['value', 'chargeType']
        }
    },
    required: ['charge']
}

export class DefineInterventionZoneForInterventionPeriodCmd {
}

DefineInterventionZoneForInterventionPeriodCmd.schema = {
    type: 'object',
    properties: {
        zone: {
            type: 'object',
            properties: {
                address: {
                    type: 'object',
                    properties: {
                        number: {type: ['string', 'null']},
                        street: {type: 'string'},
                        zipCode: {type: 'string'},
                        city: {type: 'string'}
                    },
                    required: ['street', 'zipCode', 'city']
                },
                range: {
                    type: 'object',
                    properties:{
                        value: {type: 'number'}
                    },
                    required: ['value']
                }
            },
            required: ['address', 'range']
        }
    },
    required: ['zone']
}

export class DefineCallOutChargesForInterventionPeriodCmd {
}

DefineCallOutChargesForInterventionPeriodCmd.schema = {
    type: 'object',
    properties: {
        callOutCharges: {
            type: 'array',
            minItems: 1,
            items: {
                type: 'object',
                properties: {
                    range: {
                        type: 'object',
                        properties: {
                            start: {type: 'number'},
                            end: {type: 'number'}
                        },
                        required: ['start']
                    },
                    charge: {
                        type: 'object',
                        properties: {
                            value: {type: 'number'}
                        },
                        required: ['value']
                    }
                },
                required: ['range', 'charge']
            }
        }
    },
    required: ['callOutCharges']
}

export class SubscribeProviderCompanyToDirectoryForInterventionPeriodCmd {
}

SubscribeProviderCompanyToDirectoryForInterventionPeriodCmd.schema = {
    type: 'object',
    properties: {
        subscriptions: {
            type: 'array',
            minItems: 1,
            maxItems: 2,
            items: {
                type: 'object',
                properties: {
                    forWhat: {
                        type: 'array',
                        minItems: 1
                    },
                    forWho: {type: 'string'}
                },
                required: ['forWhat', 'forWho']
            }
        }
    },
    required: ['subscriptions']
}

export class DefineContactInfosForProviderCompanyCmd {
}

DefineContactInfosForProviderCompanyCmd.schemaCache = cache()

DefineContactInfosForProviderCompanyCmd.schema = {
    type: 'object',
    properties: {
        namez: {
            oneOf: [{
                type: 'object',
                properties: {
                    firstName: {type: 'string'},
                    lastName: {type: 'string'},
                    gender: {type: ['string', 'null']},
                    nameType: {
                        type: 'string',
                        enum: ['CivilName']
                    }
                },
                required: ['firstName', 'lastName', 'nameType']
            }, {
                type: 'object',
                properties: {
                    value: {type: 'string'},
                    nameType: {
                        type: 'string',
                        enum: ['PoorName']
                    }
                },
                required: ['value', 'nameType']
            }]
        },
        emails: {
            type: 'array',
            items: {
                type: 'string',
                format: 'email'
            }
        },
        phones: {
            type: 'array',
            items: {
                type: 'string',
                format: 'phone'
            }
        },
        fax: {
            type: 'array',
            items: {
                type: 'string',
                format: 'phone'
            }
        }
    },
    required: ['namez']
}

DefineContactInfosForProviderCompanyCmd.selectSchema = (cmd) => {
    const nameType = cmd && cmd.namez && cmd.namez.nameType || 'CivilName'

    return DefineContactInfosForProviderCompanyCmd.schemaCache(nameType, () => {
        const namezSchema = DefineContactInfosForProviderCompanyCmd.schema.properties.namez.oneOf.find((schema) => {
            return schema.properties.nameType.enum.indexOf(nameType) >= 0
        })

        return {
            ...DefineContactInfosForProviderCompanyCmd.schema,
            properties: {
                ...DefineContactInfosForProviderCompanyCmd.schema.properties,
                namez: namezSchema
            }
        }
    })
}

export class DefineRepairTimelimitForInterventionPeriodCmd {
}

DefineRepairTimelimitForInterventionPeriodCmd.schema = {
    type: 'object',
    properties: {
        timelimits: {
            type: 'array',
            minItems: 1,
            items: {
                type: 'object',
                properties: {
                    timelimit: {
                        type: 'object',
                        properties: {
                            value: {type: 'number'}
                        },
                        required: ['value']
                    },
                    openingTicketPurposes: {
                        type: 'array',
                        minItems: 1
                    }
                },
                required: ['timelimit', 'openingTicketPurposes']
            }
        }
    },
    required: ['timelimits']
}

export class DefineInterventionTimelimitForInterventionPeriodCmd {
}

DefineInterventionTimelimitForInterventionPeriodCmd.schema = {
    type: 'object',
    properties: {
        timelimits: {
            type: 'array',
            minItems: 1,
            items: {
                type: 'object',
                properties: {
                    timelimit: {
                        type: 'object',
                        properties: {
                            value: {type: 'number'}
                        },
                        required: ['value']
                    },
                    openingTicketPurposes: {
                        type: 'array',
                        minItems: 1
                    }
                },
                required: ['timelimit', 'openingTicketPurposes']
            }
        }
    },
    required: ['timelimits']
}

export class ExcludeOpeningTicketPurposesFromInterventionPeriodCmd {
}

ExcludeOpeningTicketPurposesFromInterventionPeriodCmd.schema = {
    type: 'object',
    properties: {
        openingTicketPurposes: {type: 'array'}
    },
    required: ['openingTicketPurposes']
}


// WEBPACK FOOTER //
// ./lib/provider/models.js